import React from 'react'
import { Calendar as BigCalendar, momentLocalizer, Views } from 'react-big-calendar'
import withDragAndDrop from 'react-big-calendar/lib/addons/dragAndDrop'
import moment from 'moment'
import 'moment/locale/pt'
import 'react-big-calendar/lib/sass/styles.scss'
import 'react-big-calendar/lib/addons/dragAndDrop/styles.scss'

const locale = (hp.settings.current_lang || hp.settings.locale || 'pt').replace(/[\W].+/, '')
moment.locale(locale)

const localizer = momentLocalizer(moment)

const messages = locale == 'pt'
	? {
		allDay: trans.get('date_all_ay'),
		previous: '<',
		next: '>',
		today: trans.get('date_today'),
		month: trans.get('date_month_tag'),
		week: trans.get('date_week_tag'),
		work_week: trans.get('date_work_week_tag'),
		day: trans.get('date_day_tag'),
		date: trans.get('attrs_date'),
		time: trans.get('attrs_time'),
		event: trans.get('attrs_event'),
		noEventsInRange: trans.get('date_no_events_in_range'),
	}
	: null

const DragAndDropCalendar = withDragAndDrop(BigCalendar)

class AgendaEvent extends React.Component {
	constructor(props) {
		super(props)
		this.onClick = this.onClick.bind(this)
	}

	onClick() {
		const { event, onSelectEvent } = this.props
		if (onSelectEvent) {
			onSelectEvent(event.event)
		}
	}

	render() {
		const { event } = this.props
		return (
			<div className="pointer" onClick={this.onClick}>
				{event.title}
			</div>
		)
	}
}

/*
function AgendaEvent() {
	return <AgendaEventComponent

	/>
}
*/

export default class Calendar extends React.Component {
	constructor(props) {
		super(props);
		this.state = {
			view: props.view || sessionStorage.getItem('calendar.view') || Views.WEEK
		};
		if (hp.store.config && hp.store.config.calendar) {
			const cfg = hp.store.config.calendar;
			if (cfg.min) {
				this.state.min = new Date(2018, 1, 0, cfg.min, 0, 0);
			}
			if (cfg.max) {
				this.state.max = new Date(2018, 1, 0, cfg.max, 0, 0);
			}
		}
		else {
			this.state.min = new Date(2018, 1, 0, 7, 0, 0);
		}
		this.onViewChanged = this.onViewChanged.bind(this)
		this.onAgenda = this.onAgenda.bind(this)
	}

	static getRangeFor = (view = null, date = null) => {
		let start, end

		if (date == null) {
			date = new Date()
		}
		else {
			start = date
		}
		view = view || sessionStorage.getItem('calendar.view') || Views.WEEK
		if (view === Views.MONTH) {
			end = new Date(date.getFullYear(), date.getMonth() + 1, 7)
			start = new Date(date.getFullYear(), date.getMonth(), 1)
			start.setDate(start.getDate() - 7)
		}
		else if (view === Views.WEEK) {
			start = new Date(date)
			// quando dia atual é domingo, getDay devolve 0 e, é necessário que o 1º dia a mostrar seja uma semana antes
			start.setDate(date.getDate() - (date.getDay() || 7) + 1)
			end = new Date(date)
			end.setDate(date.getDate() + 7)
		}
		else if (view === Views.WORK_WEEK) {
			start = new Date(date)
			start.setDate(date.getDate() - (date.getDay() || 7) + 1)
			end = new Date(date)
			end.setDate(date.getDate() + 5)
		}
		else {
			start = end = date
		}
		return { start, end }
	}

	onViewChanged(view) {
		sessionStorage.setItem('calendar.view', view);
		if (this.props.onViewChanged) {
			this.props.onViewChanged(view)
		}
		this.setState({ view: view });
	}

	componentDidMount() {
		this.isMobile();
	}

	isMobile() {
		if (/Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent)) {
			this.setState({ view: Views.DAY });
		}
	}

	onAgenda(event) {
		return <AgendaEvent event={event} onSelectEvent={this.props.onSelectEvent || null} />
	}

	render() {
		const props = Object.assign({
			localizer: localizer,
			messages: messages,
			events: this.props.events,
			defaultDate: this.props.defaultDate || null,
			date: this.props.date || null,
			selectable: this.props.selectable || false,
			startAccessor: this.props.startAccessor || 'evt_start',
			endAccessor: this.props.endAccessor || 'evt_end',
			titleAccessor: this.props.titleAccessor || 'title',
			tooltipAccessor: this.props.tooltipAccessor || this.props.titleAccessor || null,
			eventPropGetter: this.props.eventPropGetter || null,
			onSelectSlot: this.props.onSelectSlot || null,
			onSelectEvent: this.props.onSelectEvent || null,
			onRangeChange: this.props.onRangeChange || null,
			draggableAccessor: this.props.draggableAccessor || null,
			resizableAccessor: this.props.resizableAccessor || null,
			onEventDrop: this.props.onEventDrop || null,
			onEventResize: this.props.onEventResize || null,
			defaultView: this.props.defaultView || Views.WEEK,
			view: this.state.view,
			onView: this.onViewChanged,
			views: this.props.views || [Views.MONTH, Views.WEEK, Views.DAY, Views.AGENDA],
			onNavigate: this.props.onNavigate || null,
			components: {
				agenda: {
					event: this.onAgenda
				},
				event: this.props.renderEvent || null
			},
			showAllEvents: this.props.showAllEvents || null,
			popup: this.props.popup || null
		}, this.state);
		if (this.props.date) {
			props.date = this.props.date;
		}
		const calendar = React.createElement(this.props.dragDrop ? DragAndDropCalendar : BigCalendar, props)

		return (
			<div className={classNames("calendar", this.props.className)}>
				{calendar}
			</div>
		)
	}
}
